import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';

import { ReviewBaseComponent } from './review/review-base.component';
import { ReviewResolverComponent } from './review/review-resolver.component';
import { ReviewComponent } from './review/review.component';
import { ReviewCardComponent } from './review/review-card/review-card.component';
import { ReviewFieldComponent } from './review/review-field/review-field.component';
import { OaoModule } from '@workflow/ecp-workflow/oao/oao.module';
import { EcpSharedModule } from '@workflow/ecp-shared/shared.module';
import { OlaModule } from '@workflow/ecp-workflow/ola/ola.module';
import { DynamicWorkflowModule } from '@workflow/dynamic-workflow.module';

const components = [ReviewBaseComponent, ReviewResolverComponent, ReviewComponent, ReviewCardComponent, ReviewFieldComponent];
@NgModule({
  declarations: [...components],
  imports: [CommonModule, FormsModule, RouterModule, SharedUiLibraryModule, EcpSharedModule, OaoModule, OlaModule, DynamicWorkflowModule],
  exports: [...components]
})
export class PagesModule {}
